import apiClient from "./apiClient";

export const getMyCapabilities = () =>
  apiClient.get("/api/me/capabilities").then((response) => response.data);
